var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { CFIcon } from '../../../components';
import { commonAttrs } from '../../../utils';
import { CFIconBadgeElements } from './IconBadge.styles';
import { CFBaseIconBadgeUtils } from '@connectrn/ds-ui-base';
export const CFIconBadge = (_a) => {
    var { badgeColor, borderColor, colorway = 'default', icon, iconColor, iconSize, size = 'lg', strength = 'strong' } = _a, rest = __rest(_a, ["badgeColor", "borderColor", "colorway", "icon", "iconColor", "iconSize", "size", "strength"]);
    const { Root } = CFIconBadgeElements;
    return (React.createElement(Root, Object.assign({ badgeColor: badgeColor, borderColor: borderColor, colorway: colorway, size: size, strength: strength }, commonAttrs(rest)),
        React.createElement(CFIcon, { color: CFBaseIconBadgeUtils.iconColor({
                colorway,
                iconColor,
                strength,
            }), icon: icon, size: CFBaseIconBadgeUtils.iconSize({ iconSize, size }) })));
};
